import { StandardEvents } from '@shopify/events';

/**
 * Keeps the PDP heading (".pdp-product-title") in sync with the selected variant,
 * appending the variant's differentiating option (e.g. colour/size) to the base product title.
 */
document.addEventListener(StandardEvents.productSelect, (event) => {
  if (
    !(event.target instanceof Element) ||
    event.target.closest('product-card') ||
    event.target.closest('quick-add-dialog')
  ) {
    return;
  }

  event.promise
    .then(({ detail }) => {
      const titleElement = document.querySelector('.pdp-product-title');
      if (!titleElement) return;

      const baseTitle = titleElement.getAttribute('data-base-title') ?? '';
      const variantTitle = detail?.resource?.title;

      titleElement.textContent =
        variantTitle && variantTitle !== 'Default Title' ? `${baseTitle} - ${variantTitle}` : baseTitle;
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[product-title] Event promise rejected:', error);
    });
});
